import axios from "axios"

/**
 * Lockton dev API base for postcode lookup via the GEE proxy (no env variable).
 * Endpoint: GET .../api/proxy/gee/GlobalExpressFreeForm?ff={postcode}
 */
const LOCKTON_DEV_LOOKUP_BASE = "https://locktondev.insurforce.co.uk"

export const POSTCODE_REGEX =
  /^([A-PR-UWYZ][0-9][A-HK-Y0-9]?|[A-PR-UWYZ][A-HK-Y0-9][0-9][ABEHMNPRVWXY0-9]?) {0,2}[0-9][ABD-HJLN-UW-Z]{2}$|^GIR 0AA$/i

export function isValidPostcode(postcode) {
  return POSTCODE_REGEX.test(String(postcode || "").trim())
}

/** Normalise UK postcode for display/storage: uppercase, single space before inward code (last 3 chars). */
export function formatUkPostcodeDisplay(postcode) {
  const compact = String(postcode || "")
    .toUpperCase()
    .replace(/\s+/g, "")
  if (!compact) return ""
  if (compact.length <= 3) return compact
  return `${compact.slice(0, -3)} ${compact.slice(-3)}`
}

function mapGeeResultToActivityAddress(item) {
  const a = item.Address || {}
  const address1Parts = [a.Premise, a.Building, a.Thoroughfare].filter(
    (x) => !!x && String(x).trim().length > 0
  )
  // Same as home-admin Lockton fetchAddressesFreeForm: do not fill address2/3 from GEE;
  // city = Locality || City (mapped to address4; the City input in AddressForm is bound to address4).
  return {
    description: a.Address || "",
    postcode: a.PostalCode || "",
    address1: address1Parts.join(", "),
    address2: "",
    address3: "",
    flatNumber: a.SubBuilding || "",
    address4: a.Locality || a.City || "",
    address5: a.AdminAreaName || a.ProvinceName || ""
  }
}

/**
 * Fetches address list for a UK postcode (Melissa GlobalExpress via Lockton dev proxy).
 * @param {string} postcode
 * @param {{ signal?: AbortSignal }} [requestOptions]
 */
export async function fetchAddressesByPostcode(postcode, requestOptions = {}) {
  const sanitizedPostcode = (postcode || "")
    .toString()
    .trim()
    .replace(/\s+/g, "")

  const { data } = await axios.get(
    `${LOCKTON_DEV_LOOKUP_BASE}/api/proxy/gee/GlobalExpressFreeForm`,
    {
      params: { ff: sanitizedPostcode },
      signal: requestOptions.signal
    }
  )

  const results = data?.Results ?? []
  return results.map(mapGeeResultToActivityAddress)
}

export default {
  fetchAddressesByPostcode,
  formatUkPostcodeDisplay,
  isValidPostcode,
  POSTCODE_REGEX
}
